"use client";

import React from "react";
import { useEffect } from "react";
import Image from "next/image";
import { useState } from "react";
import Link from "next/link";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HomePage = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hasShown = sessionStorage.getItem("admissionModalShown");

      if (!hasShown) {
        import("bootstrap/dist/js/bootstrap.bundle.min.js").then(() => {
          const modalEl = document.getElementById("admissionModal");
          if (modalEl) {
            const bootstrap = require("bootstrap");
            const modal = new bootstrap.Modal(modalEl, {
              backdrop: "static",
              keyboard: false,
            });
            modal.show();

            // Mark as shown
            sessionStorage.setItem("admissionModalShown", "true");
          }
        });
      }
    }
  }, []);

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://elangomatricschool.in/api/event-page.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.Status === "Success" && Array.isArray(data.data)) {
          setEvents(data.data);
        } else {
          console.error("API error:", data.Message);
        }
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  // Group events in sets of 3 for carousel items
  const chunkEvents = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const chunkedEvents = chunkEvents(events, 3);
  const [galleryImages, setGalleryImages] = useState([]);
  const fallbackImages = [
    "/assets/images/pick/event-1.png",
    "/assets/images/pick/event-2.png",
    "/assets/images/pick/event-3.png",
    "/assets/images/pick/event-5.png",
  ];

  useEffect(() => {
    fetch("https://elangomatricschool.in/api/gallery-images-list.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (
          data.Status === "Success" &&
          Array.isArray(data.images) &&
          data.images.length > 0
        ) {
          setGalleryImages(data.images.slice(0, 4)); // Only take 4 dynamic images max
        } else {
          console.warn("Using fallback images");
          setGalleryImages(fallbackImages);
        }
      })
      .catch((error) => {
        console.error("API Error, using fallback:", error);
        setGalleryImages(fallbackImages);
      });
  }, []);

  return (
    <>
      {/* Start Banner Area */}
      <div className="banner-area">
        <div className="container-fluid">
          <div className="slider-item banner-bg-1">
            {/* You can replace banner-bg-1 with your own style */}
            <div className="overlay"></div>
            <div className="slider-content">
              <h1>Discover, Learn &amp; Lead With Confidence</h1>
              <p>
                Our mission is to inspire students to reach their highest
                potential through values-based and future-ready education.
              </p>
              <Link href="/contact" className="default-btn btn">
                Begin Your Learning Journey <i className="flaticon-next"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* End Banner Area */}

      {/* Start Campus Information Area */}
      <div className="campus-information-area pb-70 pt-70">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Text */}
            <div className="col-lg-6">
              <div className="campus-content pr-20">
                <div className="campus-title">
                  <h2>ABOUT US</h2>
                  <h3 className="abt-head">
                    Welcome to Elango Matriculation School
                  </h3>
                  <p className="abt-desc">
                    Established in 1987 by the visionary Elango Educational
                    Trust, our school has a legacy of academic excellence and
                    character-building.
                  </p>
                  <p className="abt-desc">
                    From its inception, the school has been committed to
                    offering high-quality education that nurtures the
                    intellectual, emotional, and physical development of each
                    child.
                  </p>
                </div>

                {/* Counters */}
                <div className="counter">
                  <div className="row">
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h1>
                          <span className="odometer" data-count="30">
                            30
                          </span>
                          <span className="target">+</span>
                        </h1>
                        <p>Years Of Legacy</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h1>
                          <span className="odometer" data-count="1">
                            1
                          </span>
                          <span className="target heading-color">k</span>
                          <span className="target">+</span>
                        </h1>
                        <p>Students</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h1>
                          <span className="odometer" data-count="120">
                            50
                          </span>
                          <span className="target">+</span>
                        </h1>
                        <p>Dedicated Staffs</p>
                      </div>
                    </div>
                  </div>
                </div>

                <Link href="/contact" className="default-btn btn">
                  Know More <i className="flaticon-next"></i>
                </Link>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-6">
              <div className="campus-image pl-20">
                <img
                  src="/assets/images/pick/aboutimg-1.png"
                  alt="About Elango School"
                  className="abt-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Campus Information Area */}

      {/* Start Vision, Mission, Core Values Section */}
      <section className="pt-1 pb-5">
        <div className="container">
          <div className="row text-center">
            {/* Vision */}
            <div className="col-md-4 mb-4">
              <div className="p-4 border h-100 shadow-sm rounded card-hover">
                <div className="mb-3">
                  <img
                    src="/assets/images/pick/vision.png"
                    alt="Vision Icon"
                  />
                </div>
                <h5 className="fw-bold">Vision</h5>
                <p className="text-muted">
                  Nurturing curious minds, inspiring creativity, and shaping
                  future-ready individuals.
                </p>
              </div>
            </div>

            {/* Mission */}
            <div className="col-md-4 mb-4">
              <div className="p-4 border h-100 shadow-sm rounded card-hover">
                <div className="mb-3">
                  <img
                    src="/assets/images/pick/mission.png"
                    alt="Mission Icon"
                  />
                </div>
                <h5 className="fw-bold">Mission</h5>
                <p className="text-muted">
                  To provide an enjoyable learning experience, by empowering our
                  teachers to apply appropriate techniques to a relevant
                  curriculum, for all-round development of children.
                </p>
              </div>
            </div>

            {/* Core Values */}
            <div className="col-md-4 mb-4">
              <div className="p-4 border h-100 shadow-sm rounded card-hover">
                <div className="mb-3">
                  <img
                    src="/assets/images/pick/values.png"
                    alt="Values Icon"
                  />
                </div>
                <h5 className="fw-bold">Core Values</h5>
                <p className="text-muted">
                  Discipline, Collaboration, Hardwork, Creativity and
                  Independence guide every step of our journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Vision, Mission, Core Values Section */}

      {/* CTA Section Start */}
      <div
        className="cta-section position-relative text-white"
        style={{
          background:
            "url('/assets/images/pick/cta-1.png') center center/cover no-repeat",
        }}
      >
        <div
          className="overlay position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(17, 29, 94, 0.9)", zIndex: 1 }}
        ></div>

        <div className="container position-relative py-5" style={{ zIndex: 2 }}>
          <div className="row align-items-center">
            {/* Left: Text */}
            <div className="col-md-8 mb-3 mb-md-0">
              <h2 className="fw-bold m-0 text-white">
                Let Elango Matriculation School Shape Your Child’s Future
                Through Knowledge, Discipline & Leadership.
              </h2>
            </div>

            {/* Right: Button */}
            <div className="col-md-4 text-md-end">
              <Link href="/contact" className="default-btn btn">
                Apply for Admission<i className="flaticon-next"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section End */}

      {/* Gallery Section */}
      <div className="container pt-70">
        <div className="text-center mb-4">
          <h2 className="font-weight-bold">Lively and Happy Campus!</h2>
          <p>
            Our campus is a place where smiles bloom and learning comes alive.
            From joyful assemblies to engaging classrooms, every corner echoes
            with laughter, creativity, and curiosity!
          </p>
        </div>

        <div className="row">
          {/* Column 1: Static image */}
          <div className="col-md-4 mb-4">
            <img
              src="/assets/images/pick/gallery-1.png"
              className="img-fluid h-90 w-100"
              style={{ objectFit: "cover" }}
              alt="Dance"
            />
          </div>

          {/* Column 2 & 3: Dynamic images */}
          {[0, 1].map((col) => (
            <div className="col-md-4 mb-4" key={col}>
              {galleryImages.slice(col * 2, col * 2 + 2).map((url, idx) => (
                <div className={idx === 0 ? "mb-3" : ""} key={idx}>
                  <img
                    src={url}
                    className="img-fluid w-100"
                    style={{ height: "268px", objectFit: "cover" }}
                    alt={`Gallery ${col * 2 + idx + 2}`}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonial / CTA Section */}
      <section className="testimonial-section mt-5">
        <div className="testimonial-content">
          <h3 className="cta-head">
            We Shape Young Hearts and Growing Minds for a Brighter Tomorrow
          </h3>
          <p>
            Beyond textbooks and classrooms, we believe in nurturing every
            child’s unique spark. We create a space where talents are
            discovered, confidence is built, and dreams begin to take shape.
          </p>

          <Link href="/contact" className="default-btn btn mt-3">
            Join Now <i className="flaticon-next"></i>
          </Link>
        </div>
      </section>

      {/* Admission Popup (image poster) */}
      <div
        className="modal fade"
        id="admissionModal"
        tabIndex="-1"
        aria-labelledby="admissionModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-0 border-0 position-relative overflow-hidden">
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              className="btn-close position-absolute bg-white rounded-circle p-2"
              style={{ top: 10, right: 10, zIndex: 5, opacity: 1 }}
            ></button>

            <img
              src="/assets/images/pick/admissions.jpeg"
              alt="Elango Matriculation School Admissions Open 2026-2027"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </div>
        </div>
      </div>

      {/* Latest News and Events */}
      <div className="events-area pt-70 pb-70">
        <div className="container">
          <div className="section-title text-center mb-4">
            <h2>Latest News and Events</h2>
            <p>
              Stay updated with our latest happenings, and events that shape our
              vibrant community.
            </p>
          </div>

          {loading ? (
            <p className="text-center">Loading events...</p>
          ) : events.length === 0 ? (
            <p className="text-center text-danger">No events found.</p>
          ) : (
            <div
              id="eventCarousel"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {chunkedEvents.map((group, idx) => (
                  <div
                    key={idx}
                    className={`carousel-item ${idx === 0 ? "active" : ""}`}
                  >
                    <div className="row">
                      {group.map((event, i) => (
                        <div className="col-md-4" key={i}>
                          <div className="single-events-card style2">
                            <div className="events-image">
                              <Link href={`/events/${event.slug_url}`}>
                                <Image
                                  src={event.image_url}
                                  alt={event.title}
                                  width={412}
                                  height={260}
                                  className="d-block w-100"
                                  style={{ objectFit: "cover" }}
                                  unoptimized
                                />
                              </Link>
                            </div>
                            <div className="events-content p-3">
                              <Link href={`/events/${event.slug_url}`}>
                                <h3>{event.title}</h3>
                              </Link>
                              <div className="admin-and-date">
                                <ul className="d-flex justify-content-between list-unstyled">
                                  <li>
                                    <p>
                                      <i className="flaticon-student-with-graduation-cap"></i>{" "}
                                      Admin
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <i className="flaticon-clock"></i>{" "}
                                      {event.date}
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#eventCarousel"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#eventCarousel"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HomePage;